import React, {useContext, useEffect, useRef, useState} from "react";
import {exportReportById, getReportById} from "../../../../api/weightSlip";
import {Button, Empty, Form, Input, message, Table} from "antd";
import moment from "moment/moment";
import * as XLSX from "xlsx";
import * as XLSXStyle from "xlsx";
import * as FileSaver from 'file-saver';
import {addListMergeName, addMergeName} from "../../../../api/mergeName";

const EditableContext = React.createContext(null);
const EditableRow = ({index, ...props}) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('trung Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} rootClassName={"w-[300px]"}/>
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap w-[300px]"
                style={{
                    paddingRight: 24,
                    height: 40,
                    border: "1px solid #D0D5DD ",
                    borderRadius: 8,
                    alignItems: "center",
                    display: "flex",
                    paddingLeft: 8
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};

const View = ({id, name, exportData, exportDataMerge, onExportData, onExportDataMerge, databaseKey, onData}) => {

    const [dataNew, setData] = useState([])
    const [dataChild, setDataChild] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowKeysChild, setSelectedRowKeysChild] = useState([])
    const [checkMerge, setCheckMerge] = useState(false)
    const [dataItem, setDataItem] = useState()
    const [convertMerge, setConvertMerge] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        if (checkMerge) {
            let arrayId = dataChild.filter(itemChild => itemChild.keyCompare === dataItem).map(itemMap => itemMap.key)
            let arrayMerge = selectedRowKeysChild.filter(itemKey => arrayId.includes(itemKey))

            if (arrayMerge.length > 0) {
                let listKh = dataChild.filter(itemChild => arrayMerge.includes(itemChild.key))
                    .map(itemMap => itemMap.key)
                let name = dataNew.filter(itemData => itemData.key === dataItem)
                if (name.length > 0) {
                    addMergeName(databaseKey, {
                        name: name[0].khachHang,
                        listKhachHang: listKh,
                        reportId: id
                    }).then(r => {
                        setReload(!reload)
                        message.success("Hợp nhất tên thành công")
                    })
                        .catch(() => {
                            message.error("Hệ thống đã gặp sự cố")
                        })
                }
            }

            setCheckMerge(false)
            setDataItem(undefined)
        }
    }, [checkMerge])

    const mapParent = (data) => {

        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                key: item,
                title: "Tên hợp nhất",
                khachHang: item,
                button: <Button style={{
                    height: 40,
                    marginBottom: 2,
                    marginTop: 2,
                    border: "1px solid #007FFF",
                    color: "#007FFF",
                    borderRadius: 8,
                    width: 109
                }} onClick={() => {
                    setCheckMerge(true)
                    setDataItem(item)
                }}>
                    Hợp nhất
                </Button>,
            };
        });
    }
    const mapChild = (data) => {

        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                key: item.weightSlipId,
                keyCompare: item.key ? item.key : "",
                khachHangOrigin: item.khachHang ? item.khachHang : "",
                soXe: item.soXe
            };
        });
    }

    useEffect(() => {
        getReportById(id).then(r => {
            setSelectedRowKeys(r.unifiedNameList)
            setSelectedRowKeysChild(r.reportUnifiedUiList?.map(item => item.weightSlipId))
            setData(mapParent(r.unifiedNameList))
            setDataChild(mapChild(r.reportUnifiedUiList))
            onData(r.unifiedNameList)
        })
    }, [reload])
    const mapData = (value) => {
        if (!value) {
            return [];
        }
        return value?.map((item) => {
            return {
                "Mã phiếu": item.maPhieu,
                "Khách hàng": item.khachHangCompare,
                "Tên hàng": item.tenHang,
                "Mã hàng": item.maHang,
                "Mã khách hàng": item.maKH,
                "Biển số xe": item.soXe,
                "Khối lượng có tải": item.coTai,
                "Khối lượng không tải": item.tareWeight,
                "Trọng lượng hàng": item.hang,
                "Ngày cân": moment(item.ngayCan).format("DD/MM/YYYY"),
                "Giờ có tải": moment(item.gioCoTai).format("HH:mm:ss"),
                "Giờ Không tải": moment(item.gioKTai).format("HH:mm:ss"),
                "Đơn giá": item.donGia,
                "Thành tiền": item.thanhTien,

            };
        });
    }
    const exportExcel = (datasource) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        let dataArray = mapData(datasource)
        const ws = XLSX.utils.json_to_sheet(dataArray);
        ws["!cols"] = [{wch: 15}, {wch: 25}, {wch: 15}, {wch: 25}, {wch: 15},
            {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25},
            {wch: 25}, {wch: 25}, {wch: 25}];
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSXStyle.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, name + fileExtension);

    }

    useEffect(() => {
        if (exportData) {
            exportReportById(id, "report").then(r => {
                exportExcel(r)
            })
                .catch(() => {
                    console.log("error")
                })
            onExportData();
        }
    }, [exportData])

    useEffect(() => {
        if (exportDataMerge) {
            let dataList = []

            dataNew.map(item => {
                let arrayId = dataChild.filter(itemChild => itemChild.keyCompare === item.key).map(itemMap => itemMap.key)
                let arrayMerge = selectedRowKeysChild.filter(itemKey => arrayId.includes(itemKey))

                if (arrayMerge.length > 0) {
                    let listKh = dataChild.filter(itemChild => arrayMerge.includes(itemChild.key))
                        .map(itemMap => itemMap.key)
                    let name = dataNew.filter(itemData => itemData.key === item.key)

                    if (name.length > 0) {
                        dataList.push({
                            name: name[0].khachHang,
                            listKhachHang: listKh,
                            reportId: id
                        })
                    }
                }
            })

            addListMergeName(databaseKey, dataList).then(res => {
                exportReportById(id, "special").then(r => {
                    exportExcel(r)
                })
                    .catch(() => {
                        console.log("error")
                    })
            })
                .catch(() => message.error("Hệ thống đã gặp sự cố"))

            onExportDataMerge()
        }
    }, [exportDataMerge])

    const expandedRowRender = (record) => {
        const columnsExpanded = [
            {
                dataIndex: "temp",
                key: "temp",
                width: 29
            },
            {
                title: "khachHangOrigin",
                dataIndex: "khachHangOrigin",
                key: "khachHangOrigin",
                width: 144
            },
            {
                title: "soXe",
                dataIndex: "soXe",
                key: "soXe",
                width: 330
            },
        ];
        return (
            <Table
                columns={columnsExpanded}
                dataSource={dataChild?.filter(item => item.keyCompare === record.key)}
                pagination={false}
                rowSelection={rowSelectionChild}
                showHeader={false}
                className={"customer_table_expanded"}
                locale={{
                    emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                      description={"không có dữ liệu nào"}/>
                }}
            />
        );
    };

    const handleSave = (row) => {

        let array = dataNew.filter(data => data.key === row.key)

        if (array.length === 1 && array[0].khachHang !== row.khachHang) {
            const indexConvertMerge = convertMerge.findIndex((item1) => row.key === item1.key);

            if (indexConvertMerge === -1) {
                setConvertMerge(convertMerge.concat({
                    key: row.key,
                    khachHang: row.khachHang
                }))
            } else {
                const newDataConvert = [...convertMerge];
                newDataConvert.splice(indexConvertMerge, 1, {
                    key: row.key,
                    khachHang: row.khachHang
                });
                setConvertMerge(newDataConvert);
            }
        }

        const newData = [...dataNew];
        const index = newData.findIndex((item1) => row.key === item1.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setData(newData);
    };

    const columns = [
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            width: 120
        },
        {
            title: "khachHang",
            dataIndex: "khachHang",
            key: "khachHang",
            width: 450,
            onCell: (record) => ({
                record,
                editable: true,
                dataIndex: "khachHang",
                title: "khachHang",
                handleSave,
            }),
        },
        {
            title: "button",
            dataIndex: "button",
            key: "button",
            width: 130
        },
    ];

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    function getDifference(array1, array2) {
        return array1.filter(object1 => {
            return !array2.some(object2 => {
                return object1 === object2;
            });
        });
    }

    const onSelectChange = (newSelectedRowKeys) => {
        const difference = [
            ...getDifference(selectedRowKeys, newSelectedRowKeys),
            ...getDifference(newSelectedRowKeys, selectedRowKeys)
        ];

        let array = dataChild.filter(item => item.keyCompare === difference[0]).map(item1 => item1.key)
        if (newSelectedRowKeys.length > selectedRowKeys.length) {
            setSelectedRowKeysChild([...new Set(selectedRowKeysChild.concat(array))])
        } else {
            let arrayAfter = selectedRowKeysChild.filter(item => !array.includes(item))
            setSelectedRowKeysChild(arrayAfter)
        }
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const onSelectChangeChild = (record, selected, selectedRows) => {

        if (selected) {
            setSelectedRowKeysChild([...new Set(selectedRowKeysChild.concat(record.key))])
        } else {
            let arrayAfter = selectedRowKeysChild.filter(item => item !== record.key)
            setSelectedRowKeysChild(arrayAfter)
        }

        let arrayAfterSelect = selectedRows.filter(item => item && item.keyCompare === record.keyCompare)
        if (arrayAfterSelect.length === 0) {
            let arrayAfter = selectedRowKeys.filter(item => item !== record.keyCompare)
            setSelectedRowKeys(arrayAfter)
        }

        let arrayAfterFilter = dataChild.filter(item => item.keyCompare === record.keyCompare)
        if (arrayAfterSelect.length === arrayAfterFilter.length) {
            setSelectedRowKeys([...new Set(selectedRowKeys.concat(record.keyCompare))])
        }
    };
    const rowSelectionChild = {
        selectedRowKeys: selectedRowKeysChild,
        onSelect: onSelectChangeChild
    };

    return (
        <>
            {
                dataNew.length === 0  ?
                    <>
                        <div className={"text-base font-semibold"} style={{color: "#007FFF", padding: "0 24px 24px 0"}}>
                            Hệ thống không phát hiện dữ liệu bị trùng lặp , bạn có thể tải báo cáo
                        </div>
                    </> :
                    <>
                        <div className={"text-base font-semibold"} style={{color: "#007FFF", padding: "0 24px 24px 0"}}>
                            Hệ thống đã phát hiện các dữ liệu bị trùng lặp, bạn có thể hợp nhất các dữ liệu bên dưới trước khi tạo
                            báo cáo
                        </div>
                        <Table
                            components={components}
                            columns={columns}
                            expandable={{
                                expandedRowRender,
                                defaultExpandAllRows: true,
                                expandIcon: ({expanded, onExpand, record}) => null
                            }}
                            rowSelection={rowSelection}
                            showHeader={false}
                            dataSource={dataNew}
                            pagination={false}
                            rootClassName={"customer_table"}
                            scroll={{
                                y: 500,
                            }}
                            locale={{
                                emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                  description={"Báo cáo không có dữ liệu "}/>
                            }}
                            style={{overflowX: "hidden"}}
                        />
                    </>
            }
        </>
    )
}

export default View
